export const sourceOptions = {
  CMS: 'CMS',
  ARTSDATA: 'ARTSDATA',
};

export const externalSourceOptions = {
  FOOTLIGHT: 'Footlight',
  ARTSDATA: 'Artsdata',
};
